import { useId, type InputHTMLAttributes, type ReactNode } from "react";
import s from "./ui.module.css";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  hilfe?: ReactNode;
  fehler?: string | null;
  /** Zusätzliche Klasse für das Eingabefeld selbst */
  eingabeKlasse?: string;
}

export function Feld({ label, hilfe, fehler, id, className, eingabeKlasse, ...rest }: Props) {
  const eigeneId = useId();
  const feldId = id ?? eigeneId;
  const hilfeId = hilfe ? `${feldId}-hilfe` : undefined;
  const fehlerId = fehler ? `${feldId}-fehler` : undefined;
  return (
    <div className={[s.feld, className].filter(Boolean).join(" ")}>
      <label className={s.label} htmlFor={feldId}>
        {label}
      </label>
      <input
        id={feldId}
        className={[s.eingabe, eingabeKlasse].filter(Boolean).join(" ")}
        aria-invalid={fehler ? true : undefined}
        aria-describedby={[hilfeId, fehlerId].filter(Boolean).join(" ") || undefined}
        {...rest}
      />
      {hilfe ? (
        <span id={hilfeId} className={s.hilfe}>
          {hilfe}
        </span>
      ) : null}
      {fehler ? (
        <span id={fehlerId} className={s.fehlertext} role="alert">
          {fehler}
        </span>
      ) : null}
    </div>
  );
}
